import React, { useState } from 'react';

const StarRatingWithComment = ({ bookId, submitReview }:any) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0); // For hover state
  const [comment, setComment] = useState('');

  return (
    <div className=' mt-10 w-[95%]'>
      <div className="flex w-[30%]">
        {[...Array(5)].map((star, index) => {
          const ratingValue = index + 1;

          return (
            <button
              key={index}
              className={`rating-star h-8 w-8 ${ratingValue <= (hover || rating) ? 'text-yellow-500' : 'text-white'}`}
              onMouseEnter={() => setHover(ratingValue)}
              onMouseLeave={() => setHover(rating)}
              onClick={() => setRating(ratingValue)}
              aria-label={`Rate ${ratingValue} out of 5 stars`}
            >
              <svg fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.785.57-1.84-.197-1.54-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" stroke="gray"/></svg>
            </button>
          );
        })}
      </div>
      <textarea
        className="my-4 appearance-none border rounded w-full py-2 px-3 text-gray-900 leading-tight focus:shadow-outline resize-none"
        rows={6} 
        placeholder="Leave a comment (optional)"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <button
        className="mt-4 bg-[#A643FE] text-white font-bold py-2 px-4 rounded button"
        style={{ marginLeft:'60%'}}
        onClick={() => submitReview(bookId, rating, comment)}
      >
        Submit Review
      </button>
    </div>
  );
};

export default StarRatingWithComment;
